/* import __COLOCATED_TEMPLATE__ from './base-go-further-card.hbs'; */
/* RESPONSIBLE TEAM: team-pricing-and-packaging */
import templateOnlyComponent from '@ember/component/template-only';

export interface Args {
  heading: string;
  body: string;
}

interface Signature {
  Args: Args;
  Blocks: any;
  Element: HTMLElement;
}

const BaseGoFurtherCard = templateOnlyComponent<Signature>();
export default BaseGoFurtherCard;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'ExpiredSubscription::GoFurther::BaseGoFurtherCard': typeof BaseGoFurtherCard;
    'expired-subscription/go-further/base-go-further-card': typeof BaseGoFurtherCard;
  }
}
